import { ModalV3 } from "src/components/ModalV3/ModalV3.tsx";
import React, { Suspense } from "react";
import { ResourceList } from "src/system/ResourceList.tsx";
import type { GridRowParams } from "@mui/x-data-grid-premium";
import { useTranslation } from "react-i18next";
import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { getResourceI18nNamespace } from "src/system/getResourceI18nNamespace.ts";

export const ResourceListModal = ({
  resource,
  isModalOpen,
  onModalOpen,
  onRowClick,
  include,
  withoutDescendants,
}: {
  resource: string;
  isModalOpen: boolean;
  onModalOpen: (isModalOpen: boolean) => void;
  onRowClick: (params: GridRowParams<any>) => void;
  withoutDescendants?: boolean;
  include?: string[];
}) => {
  const { t } = useTranslation(getResourceI18nNamespace(resource));

  return (
    isModalOpen && (
      <ModalV3 onClose={() => onModalOpen(false)}>
        <ModalV3.Positioner>
          <ModalV3.Content>
            <ModalV3.CloseTrigger />
            <ModalV3.Header>
              <ModalV3.Title>{t(`all`)}</ModalV3.Title>
            </ModalV3.Header>

            <ModalV3.Body>
              <div css={containerStyles}>
                <Suspense fallback={null}>
                  <ResourceList
                    expandRowOnRowClick={true}
                    withoutDescendants={withoutDescendants}
                    resource={resource}
                    include={include}
                    hideToolbarCreateNewRecordButton={true}
                    disableStatePersistenceToUrl={true}
                    onRowClick={(params) => {
                      onRowClick(params);
                      onModalOpen(false);
                    }}
                  />
                </Suspense>
              </div>
            </ModalV3.Body>
          </ModalV3.Content>
        </ModalV3.Positioner>
      </ModalV3>
    )
  );
};

const containerStyles = ({ sizes }: ExactTheme) =>
  css({
    width: "90vw",
    // maxWidth: sizes.width.maxModalWidth,
    height: "85vh",
  });
